import React, { useState, useEffect }  from "react";
import Graph from '../../components/Graph';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {
    FaWalking,
    FaBicycle,
    FaMotorcycle,
    FaCarSide,
    FaShuttleVan,
    FaTruckPickup,
    FaTruck,
    FaBus,
    FaTruckMoving,
    FaRegQuestionCircle,
    } from 'react-icons/fa';
import moment from 'moment';

import DataReportDetXls from './DataReportDetXls';

const Volume = (props) => {
    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = () => setShowModal(true);
    const {
        volumeGraph,
        volumeTbl,
        // options,
        assetName,
        zone,
        vehicleCountZone,
        zoneClass,
        gapZone,
        vehicleCountZoneTbl,
        dateSel,
        dateSelTo,
        formatDate,
        setZone,
        setZoneClass,
        countsh,
        setVolumeGraph,
        setvolumeTbl,
        assets,
        asset,
        setGapZone,
        setVehicleCountZone,
        setVehicleCountZoneTbl,
        chartColors
     } = props

    //  console.log("chartColors",chartColors)

    // Graph options
    const options = {
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        scales: {
            y: { ticks: { beginAtZero: true } },
        },
        plugins: {
            customCanvasBackgroundColor: {
              color: 'lightGreen',
            },
            datalabels: { display: false }
          },

    };
    // VOLUME START
    // --------------------------
    useEffect(() => {
        // Volume vehicle count / Zone
        const getVolume = () => {

            const az = assets.find(i => i.id === asset)

            let vClass = ['PEDESTRIAN','BIKE','MOTORBIKE','CAR','VAN','SHORT TRUCK','MED TRUCK','LONG TRUCK','BUS','UNDEFINED'];    //All classes
            let vZone = (az && az.zones) || [];     //All assets zones
            let vol = []
            let volFinal = []

            // console.log(countsh)
            countsh.forEach((item) => {
                Object.keys(item).forEach((key) => {
                    if (typeof item[key] === 'object' && item[key] !== null) {
                            // console.log(item)
                            // console.log(key)
                            for (let c = 0; c < vClass.length; c++){
                                // console.log(key + " " + vClass[c] + " " + item[key][vClass[c]].VOLUME)
                                const obj = {
                                    zone: key,
                                    class: vClass[c],
                                    volume: (item[key][vClass[c]] && item[key][vClass[c]].VOLUME) || 0
                                }
                                // console.log(obj)
                                vol = [...vol, obj ]
                            }
                    }
                })

            })

            // filter zones & get label from asset
            const zones = [...new Set(vol.map(item => item.zone))];

            vZone = vZone.filter(x => zones.includes(x.id));

            for (let z = 0; z < vZone.length; z++){
                const obj = {}
                let classZone = []
                obj.id = vZone[z].id
                vZone[z].label ? obj.zone = vZone[z].label : obj.zone = vZone[z].id;

                for (let c = 0; c < vClass.length; c++){
                    const volume = vol.filter(item => {return item.class === vClass[c] && item.zone === vZone[z].id })
                                    .reduce((sum, item) => {return sum = sum + item.volume }, 0)
                    classZone = [...classZone, volume]
                }

                obj.class = classZone;
                volFinal = [...volFinal, obj ]
            }

            // Graph START
            // Graph data
            const data = {
                labels: volFinal.map(x => x.zone),
                datasets: [{
                    label: 'Count',
                    data: volFinal.map(x => x.class).map(y => y.reduce((a, b) => a+b)),
                    borderColor: [
                        // 'rgba(75, 192, 192, 0.2)',
                        chartColors[10]
                    ],
                    backgroundColor: [
                        // 'rgba(75, 192, 192, 1)',
                        chartColors[10]
                    ],
                    borderWidth: 1,
                    stack: 1
                }]
            }
            setVolumeGraph(data)
            // Graph END
            setvolumeTbl(volFinal);
        }

        getVolume();
    // eslint-disable-next-line 
    },[countsh, assets, asset, setvolumeTbl, setVolumeGraph]);
    // VOLUME END

    // VOLUME ZONE GRAPH START
    // --------------------------
    useEffect(() => {
        // Volume vehicle count / Zone
        const getGraph = () => {
            if (zone && zone.class){

                let data = {}

                if (zone && zone.class[6]===0 &&  zone.class[8]===0){
                // Graph data
                data = {
                    labels: ['Pedestrian', 'Bike','Motorbike', 'Car', 'Van', 'Short Truck', 'Long Truck', 'Undefined'],
                    datasets: [{
                        label: 'Count',
                        data: [zone.class[0], zone.class[1], zone.class[2], zone.class[3], zone.class[4], zone.class[5], zone.class[7], zone.class[9],],
                        borderColor:[
                        chartColors[1], 
                        chartColors[5], 
                        chartColors[8], 
                        chartColors[7], 
                        chartColors[4], 
                        chartColors[2], 
                        // chartColors[6], 
                        chartColors[3], 
                        // chartColors[0], 
                        chartColors[9]],
                        backgroundColor: [
                            chartColors[1], 
                            chartColors[5], 
                            chartColors[8], 
                            chartColors[7], 
                            chartColors[4], 
                            chartColors[2], 
                            // chartColors[6], 
                            chartColors[3], 
                            // chartColors[0], 
                            chartColors[9]],
                        borderWidth: 1
                    }]
                    }
                }else{
                // Graph data
                data = {
                    labels: ['Pedestrian', 'Bike','Motorbike', 'Car', 'Van', 'Short Truck', 'Med Truck', 'Long Truck', 'Bus', 'Undefined'],
                    datasets: [{
                        label: 'Count',
                        data: [zone.class[0], zone.class[1], zone.class[2], zone.class[3], zone.class[4], zone.class[5], zone.class[6], zone.class[7], zone.class[8], zone.class[9],],
                        borderColor:[
                        chartColors[1], 
                        chartColors[5], 
                        chartColors[8], 
                        chartColors[7], 
                        chartColors[4], 
                        chartColors[2], 
                        chartColors[6], 
                        chartColors[3], 
                        chartColors[0], 
                        chartColors[9]],
                        backgroundColor: [
                            chartColors[1], 
                            chartColors[5], 
                            chartColors[8], 
                            chartColors[7], 
                            chartColors[4], 
                            chartColors[2], 
                            chartColors[6], 
                            chartColors[3], 
                            chartColors[0], 
                            chartColors[9]],
                        borderWidth: 1
                    }]
                }
                }

                setZoneClass(data);
            }
        }
        getGraph();
    // eslint-disable-next-line 
    },[zone, setZoneClass]);
    // VOLUME ZONE GRAPH END

    // GAP & HEADWAY by ZONE START
    // --------------------------
    useEffect(() => {
        // Gap & Headway
        const getGapHeadway = () => {
            // console.log(zone)
            let vClass = ['PEDESTRIAN','BIKE','MOTORBIKE','CAR','VAN','SHORT TRUCK','MED TRUCK','LONG TRUCK','BUS','UNDEFINED'];    //All classes
            let arr = []
            let arrFinal = []

            countsh.forEach((item) => {
                Object.keys(item).forEach((key) => {
                    if (typeof item[key] === 'object' && item[key] !== null) {
                            // console.log(item)
                            // console.log(key)
                        if (key === zone.id)
                            for (let c = 0; c < vClass.length; c++){
                                // console.log(key + " " + vClass[c] + " " + item[key][vClass[c]].VOLUME)
                                const obj = {
                                    zone: key,
                                    date_iso: item.date_iso,
                                    class: vClass[c],
                                    gap: (item[key][vClass[c]] && item[key][vClass[c]].GAP) || 0,
                                    headway: (item[key][vClass[c]] && item[key][vClass[c]].HEADWAY) || 0
                                }
                                // console.log(obj)
                                arr = [...arr, obj ]
                            }
                    }
                })
            })

            arrFinal = arr.filter(item => item.class !== 'PEDESTRIAN' && (item.gap !== 0 || item.headway !== 0))

            setGapZone(arrFinal);
        }
        if (zone && zone.id)
            getGapHeadway();
    },[countsh, zone, setGapZone]);
    // GAP & HEADWAY by ZONE END

    // VEHICLE COUNT/HOUR by ZONE START
    // --------------------------
    useEffect(() => {
        // Vehicle count
        const getVehicleZone = () => {
            let vClass = ['PEDESTRIAN','BIKE','MOTORBIKE','CAR','VAN','SHORT TRUCK','MED TRUCK','LONG TRUCK','BUS','UNDEFINED'];    //All classes
            let arr = []
            let arrVehZone = []
            let countVh = []

            countsh.forEach((item) => {
                Object.keys(item).forEach((key) => {
                    if (typeof item[key] === 'object' && item[key] !== null) {
                            // console.log(item)
                            // console.log(key)
                        if (key === zone.id)
                            for (let c = 0; c < vClass.length; c++){
                                // console.log(key + " " + vClass[c] + " " + item[key][vClass[c]].VOLUME)
                                const obj = {
                                    zone: key,
                                    date_iso: item.date_iso,
                                    class: vClass[c],
                                    volume: (item[key][vClass[c]] && item[key][vClass[c]].VOLUME) || 0,
                                }
                                // console.log(obj)
                                arr = [...arr, obj ]
                            }
                    }
                })
            })

            // arrVehZone = arr.filter(item => item.class !== 'PEDESTRIAN' && item.class !== 'BIKE' && (item.volume !== 0))
            arrVehZone = arr.filter(item => item.volume !== 0)

            for (let hh = 0; hh < 24; hh++){

                let dataHour = arrVehZone.filter(function(item){
                    let aDate = moment(new Date(item.date_iso)).format('HH');
                    return parseInt(aDate) === hh;
                })

                countVh.push({
                    hh:hh,
                    veh: dataHour.reduce((sum, item) => {return sum = sum + parseInt(item.volume) }, 0),
                })
            }

            // Graph bar, 2 stacks: pedestrian and vehicle / hour
            const data = {
                labels: ['00:00-01:00','01:00-02:00','02:00-03:00','03:00-04:00','04:00-05:00','05:00-06:00'
                        ,'06:00-07:00','07:00-08:00','08:00-09:00','09:00-10:00','10:00-11:00','11:00-12:00'
                        ,'12:00-13:00','13:00-14:00','14:00-15:00','15:00-16:00','16:00-17:00','17:00-18:00'
                        ,'18:00-19:00','19:00-20:00','20:00-21:00','21:00-22:00','22:00-23:00','23:00-24:00'
                        ],
                datasets: [{
                    label: 'Counts',
                    data: countVh.map(x => x.veh),
                    borderColor: chartColors[10], //'rgba(75, 192, 192, 0.2)',
                    backgroundColor: chartColors[10], //'rgba(75, 192, 192, 1)',
                    borderWidth: 1,
                }]
            }
            setVehicleCountZone(data);

            setVehicleCountZoneTbl(countVh);
        }
        if (zone && zone.id)
            getVehicleZone();

    // eslint-disable-next-line 
    },[countsh, zone, setVehicleCountZone, setVehicleCountZoneTbl]);
    // VEHICLE COUNT/HOUR by ZONE END

return (
<div className="row p-2">
    <div className="col-md-12">
    <h2 className="text-header">Volume</h2>
        <div className="text-description small pb-3">
        number of vehicles per hour specified by Class that passed through the Zone
        </div>
    {/* <hr/> */}
    <div className="row">
        <div className="col-md-12 pb-2">
            {(volumeGraph.datasets && volumeGraph.datasets.length > 0)?
            <Graph
                title="Volume by Zone"
                type="bar"
                data={volumeGraph}
                options={options}
                site={assetName}
            />
            :''}
        </div>
        <div className="col-md-12">
        <Table responsive hover className="small p-0 border">
        <thead>
            <tr>
            <th className="vol-table-th-det">Zone</th>
            <th className="vol-table-th-det">Pedestrian</th>
            <th className="vol-table-th-det">Bike</th>
            <th className="vol-table-th-det">Motorbike</th>
            <th className="vol-table-th-det">Car</th>
            <th className="vol-table-th-det">Van</th>
            <th className="vol-table-th-det">Short Truck</th>
            {(volumeTbl && volumeTbl.class && volumeTbl.class[6]>0)?
            <th className="vol-table-th-det">Med Truck</th>
            :<></>}
            <th className="vol-table-th-det">Long Truck</th>
            {(volumeTbl && volumeTbl.class && volumeTbl.class[8]>0)?
            <th className="vol-table-th-det">Bus</th>
            :<></>}
            <th className="vol-table-th-det">Undefined</th>
            </tr>
        </thead>
        <tbody>

        {volumeTbl.map((x, i) =>
        <tr key={i} className="table-tr">
            <td className="table-th text-left link" onClick={() => {setZone(x); handleShowModal()} }>{x.zone}</td>
            <td className="table-td">{x.class[0]}</td>
            <td className="table-td">{x.class[1]}</td>
            <td className="table-td">{x.class[2]}</td>
            <td className="table-td">{x.class[3]}</td>
            <td className="table-td">{x.class[4]}</td>
            <td className="table-td">{x.class[5]}</td>
            {(x && x.class>0 && x.class[6]>0)?
            <td className="table-td">{x.class[6]}</td>
            :<></>}
            <td className="table-td">{x.class[7]}</td>
            {(x && x.class>0 && x.class[8]>0)?
            <td className="table-td">{x.class[8]}</td>
            :<></>}
            <td className="table-td">{x.class[9]}</td>
        </tr>
        )}

        </tbody>
        </Table>
        </div>
    </div>
    </div>

    <Modal className="DataReportModal" size="xl" show={showModal} onHide={handleCloseModal} backdrop="static" animation={false} >
            <Modal.Header className="mod-header align-content-center" closeButton>
            <Modal.Title><h4><strong>{(zone)? zone.zone :'Zone Statistics'}</strong></h4></Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {(zone && zone.class)?
                <div className="row p-2">
                    <div className="col-md-12">
                        <h3 className="text-header">Vehicle & Pedestrian Count</h3>
                    </div>
                    <div className="col-md-8 p-2">

                        {(vehicleCountZone.datasets && vehicleCountZone.datasets.length > 0)?
                        <Graph
                            title="Vehicle & Pedestrian Count"
                            type="bar"
                            data={vehicleCountZone}
                            options={options}
                            site={assetName}
                        />
                        :''}
                    </div>
                    <div className="col-md-4 p-2">
                        <Table size="sm" responsive className="small p-0 border">
                        <thead>
                            <tr>
                                <th colSpan="2" className="border-right table-th">00:00 - 06:00</th>
                                <th colSpan="2" className="border-right table-th">06:00 - 12:00</th>
                                <th colSpan="2" className="border-right table-th">12:00 - 18:00</th>
                                <th colSpan="2" className="table-th">18:00 - 24:00</th>
                            </tr>
                            <tr>
                            <th className="table-th-det">Time</th>
                            <th className="border-right table-th-det">Total</th>

                            <th className="table-th-det">Time</th>
                            <th className="border-right table-th-det">Total</th>

                            <th className="table-th-det">Time</th>
                            <th className="border-right table-th-det">Total</th>

                            <th className="table-th-det">Time</th>
                            <th className="table-th-det">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                        {vehicleCountZoneTbl.length > 0 && [...Array(6)].map((x, i) =>
                            <tr key={i} className="table-tr">
                                <td className="table-td-det text-center">{i+" - "+ (i+1)}</td>
                                <td className="border-right table-td">{vehicleCountZoneTbl[i].veh}</td>

                                <td className="table-td-det text-center">{(i+6)+" - "+ (i+7)}</td>
                                <td className="border-right table-td">{vehicleCountZoneTbl[i+6].veh}</td>

                                <td className="table-td-det text-center">{(i+12)+" - "+ (i+13)}</td>
                                <td className="border-right table-td">{vehicleCountZoneTbl[i+12].veh}</td>

                                <td className="table-td-det text-center">{(i+18)+" - "+ (i+19)}</td>
                                <td className="table-td">{vehicleCountZoneTbl[i+18].veh}</td>
                            </tr>
                        )}

                        </tbody>
                        </Table>
                    </div>
                    <div className="col-md-12">
                        <h3 className="text-header">Vehicle Classification</h3>
                    </div>
                    <div className="col-md-8 p-2">
                    {(zoneClass.datasets && zoneClass.datasets.length > 0)?
                    <Graph
                        title="Vehicle Count"
                        type="bar"
                        data={zoneClass}
                        options={options}
                        site={assetName}
                    />
                    :''}
                    </div>
                    <div className="col-md-4 p-2">
                    <Table size="sm" variant="light" responsive className="small p-0 border">
                        <thead>
                            <tr>
                            <th className="table-th-det"></th>
                            <th className="table-th-det">Vehicle type</th>
                            <th className="table-th-det">Count</th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className="table-th"><FaWalking /></td>
                            <td className="table-td-det">Pedestrian</td>
                            <td className="table-td">{zone.class[0]}</td>
                        </tr>
                        <tr>
                            <td className="table-th"><FaBicycle /></td>
                            <td className="table-td-det">Bike</td>
                            <td className="table-td">{zone.class[1]}</td>
                        </tr>
                        <tr>
                            <td className="table-th"><FaMotorcycle /></td>
                            <td className="table-td-det">Motorbike</td>
                            <td className="table-td">{zone.class[2]}</td>
                        </tr>
                        <tr>
                            <td className="table-th"><FaCarSide /></td>
                            <td className="table-td-det">Car</td>
                            <td className="table-td">{zone.class[3]}</td>
                        </tr>
                        <tr>
                            <td className="table-th"><FaShuttleVan /></td>
                            <td className="table-td-det">Van</td>
                            <td className="table-td">{zone.class[4]}</td>
                        </tr>
                        <tr>
                            <td className="table-th"><FaTruckPickup /></td>
                            <td className="table-td-det">Short Truck</td>
                            <td className="table-td">{zone.class[5]}</td>
                        </tr>
                        {(zone && zone.class>0 && zone.class[6]>0)?
                        <tr>
                            <td className="table-th"><FaTruck /></td>
                            <td className="table-td-det">Med Truck</td>
                            <td className="table-td">{zone.class[6]}</td>
                        </tr>
                        :<></>}
                        <tr>
                            <td className="table-th"><FaTruckMoving /></td>
                            <td className="table-td-det">Long Truck</td>
                            <td className="table-td">{zone.class[7]}</td>
                        </tr>
                        {(zone && zone.class>0 && zone.class[8]>0)?
                        <tr>
                            <td className="table-th"><FaBus /></td>
                            <td className="table-td-det">Bus</td>
                            <td className="table-td">{zone.class[8]}</td>
                        </tr>
                        :<></>}
                        <tr>
                            <td className="table-th"><FaRegQuestionCircle /></td>
                            <td className="table-td-det">Undefined</td>
                            <td className="table-td">{zone.class[9]}</td>
                        </tr>
                        </tbody>
                    </Table>
                    </div>
                    <div className="col-md-12 p-2">
                        <h3 className="text-header">Gap and Headway (Average / Hr)</h3>
                        <div className="row">

                            <div className="col-md-12">
                            <Table size="sm" responsive className="small p-0 border">
                            <thead>
                                <tr>
                                <th className="table-th-det">Date</th>
                                <th className="table-th-det">Time</th>
                                <th className="table-th-det">Gap [s]</th>
                                <th className="table-th-det">Headway [s]</th>
                                </tr>
                            </thead>
                            <tbody>

                            {gapZone.map((x, i) =>
                            <tr key={i}>
                                <td className="table-td">{ moment.utc(x.date_iso).local().format(formatDate[0])}</td>
                                <td className="table-td">{
                                parseInt(moment.utc(x.date_iso).local().format('HH'))+":00 - "
                                + (parseInt(moment.utc(x.date_iso).local().format('HH'))+1)+":00"
                                }</td>
                                <td className="table-td">{x.gap ? parseFloat(x.gap).toFixed(2) : '-'}</td>
                                <td className="table-td">{x.headway ? parseFloat(x.headway).toFixed(2) : '-'}</td>
                            </tr>
                            )}

                            </tbody>
                            </Table>
                            </div>
                        </div>
                    </div>
                </div>
            :''}
            </Modal.Body>
            <Modal.Footer>
            <DataReportDetXls
                vehCountZone={vehicleCountZoneTbl}
                gapZone={gapZone}
                zone={zone}
                dateFrom={dateSel}
                dateTo={dateSelTo}
                formatDate={formatDate}  />
            <Button variant="secondary" onClick={handleCloseModal}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>
</div>


)}

export default Volume;